<template>
  <a
    :href="safeUrl"
    class="game-card"
  >
    <img
      class="image"
      :style="{
        backgroundImage: `url('${image}')`
      }"
    />

    <div>
      <div class="has-xs-body-size title">
        {{ title }}
      </div>

      <div class="game-stats">
        <div class="stars">
          <StarIcon
            v-for="num in [1, 2, 3]"
            :key="num"
            :filled="num <= stars"
            :class="[
              'star',
              'animate__animated',
              'animate__bounceIn'
            ]"
            stroke="0"
          />
        </div>
        <div class="has-xs-body-size time" v-if="time">
          <ClockIcon :size="16" color="white" />
          {{ formatTime(time) }}
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import {computed, inject} from '@vue/composition-api'

import * as providers from '@area/providers'
import ClockIcon from '@/components/ClockIcon'
import StarIcon from '@/components/StarIcon'
import * as localStorage from '@/utils/local-storage'
import {formatTime} from '@/utils/time'
import {safeUrl} from '@/utils/url'

export default {
  props: {
    id: {type: String, required: true},
    title: {type: String, required: true},
    imageUrl: {type: String, required: true},
    url: {type: String, required: true},
  },
  components: {
    ClockIcon,
    StarIcon,
  },
  setup (props, context) {
    const stars = Number(localStorage.getGameItem(props.id, 'stars') || 0)
    const timeStr = localStorage.getGameItem(props.id, 'time')
    const time = typeof timeStr === 'string' ? Number(timeStr) : undefined
    const {imageUrl} = props
    const options = inject(providers.OPTIONS)

    return {
      stars,
      time,
      safeUrl: computed(() => safeUrl(props.url)),
      image: computed(() => {
        return `${options.assetBaseUrl}${imageUrl}`
      }),
      formatTime,
    }
  },
}
</script>

<style scoped lang="scss">
.game-card {
  display: flex;
  flex-direction: column;
  width: 206px;
  background-color: variables.$color-purple;
  border-radius: 40px;
  gap: 24px;
  box-shadow: 4px 4px 4px #00000015;
  color: inherit;
  text-decoration: none;
  overflow: hidden;
  transition:
    transform 300ms ease,
    box-shadow 300ms ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0px 0px 20px #FFFFFFC7;
  }

  .title {
    text-align: center;
    padding: 0 12px;
  }

  .image {
    height: 0;
    padding-bottom: 300 / 412 * 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .game-stats {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 8px 0 32px 0;
    gap: 12px;
  }

  .stars {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: variables.$spacing-32;
    gap: 8px;

    .star {
      display: block;
      width: variables.$spacing-16;
      height: variables.$spacing-16;
    }
  }

  .time {
    display: flex;
    align-items: center;
    font-weight: 400;

    svg {
      margin-right: 6px;
    }
  }

  // Mobile and tablet
  @include media.query($to: 1024) {
    width: 170px;
    max-width: calc(50% - 8px);
  }
}
</style>
